
import { motion } from "framer-motion";

export const EnglishProcessSteps = () => {
  return (
    <div className="mb-8">
      <h2 className="text-2xl font-semibold mb-4 text-blue-800">The Loan Application Process in Finland</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white border border-gray-200 p-4 rounded-lg shadow-sm">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 text-blue-600 mb-4">1</div>
          <h3 className="text-lg font-medium mb-2">Complete Application</h3>
          <p className="text-gray-600">Fill out one application to compare multiple loan offers.</p>
        </div>
        <div className="bg-white border border-gray-200 p-4 rounded-lg shadow-sm">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 text-blue-600 mb-4">2</div>
          <h3 className="text-lg font-medium mb-2">Receive Offers</h3>
          <p className="text-gray-600">Banks review your application and provide loan offers within 24 hours.</p>
        </div>
        <div className="bg-white border border-gray-200 p-4 rounded-lg shadow-sm">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 text-blue-600 mb-4">3</div>
          <h3 className="text-lg font-medium mb-2">Accept Best Offer</h3>
          <p className="text-gray-600">Compare terms and accept the offer that best meets your needs.</p>
        </div>
      </div>
    </div>
  );
};
